import React from "react";
import { Box, Typography } from "@mui/material";
import LoadingCircularProgress from "../LoadingCircularProgress";
import { PivotTable } from "./PivotTable";
import { isEmpty } from "./pivotModel";
import { WeekPicker } from "./WeekPicker";

// A pivot report's body: the table, or why there is none.
export const PivotReport = ({ model, loading, title, onCellClick, weekPicker }) => {
  if (loading) return <LoadingCircularProgress />;
  if (!model) return null;
  if (isEmpty(model)) {
    return (
      <Box sx={{ p: 6, textAlign: "center" }}>
        <Typography color="text.secondary">No specimens match these filters.</Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, px: { xs: 2, md: 3 }, py: 2 }}>
      {weekPicker && <WeekPicker {...weekPicker} />}
      <PivotTable model={model} caption={title} onCellClick={onCellClick} />
    </Box>
  );
};
